import { Injectable } from '@angular/core';

// Services
import { ServiceBase } from '../service-base';

const CLASS_NAME = 'BankStatementAutomation';
const ENDPOINT = `/bank-statement-automations/`;

@Injectable({
    providedIn: 'root'
})
export class BankStatementAutomationService extends ServiceBase {

    protected override useCache = true;

    constructor() {
        super(CLASS_NAME, ENDPOINT);
    }
}
